import { createSelector } from '@ngrx/store';
import { getTapesState } from '../store/store.selectors';
import { TapesStateInterface, selectAll } from './tapes.state';

export const getAllTapes = createSelector(
  getTapesState,
  (state: TapesStateInterface) => selectAll(state)
);
